import React from 'react';
import { t } from '@lingui/core/macro';

import EditSmall from '@rover/icons/svg/edit-small.svg';
import { Box } from '@rover/kibble/core';

import { shouldBlurElement } from '../utils';

type Props = {
  onClick: (e: React.MouseEvent) => void;
  onBlur?: () => void;
};

export default function EditButton({ onClick, onBlur }: Props): JSX.Element {
  const handleBlur = (e: React.FocusEvent): void => {
    if (shouldBlurElement(e) && onBlur) {
      onBlur();
    }
  };

  return (
    <Box
      webAs="button"
      sx={{
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
      }}
      onClick={onClick}
      webAsProps={{
        onBlur: handleBlur,
      }}
      webProps={{
        tabIndex: 0,
      }}
      aria-label={t`Edit address`}
      id="edit-button"
    >
      <EditSmall width={18} height={18} />
    </Box>
  );
}
